module.exports = __webpack_public_path__ + "media/images/emblems/Mendrisio-coat_of_arms-ac311007ad35a704a30db0a72efdfb56.svg";